import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "../../services/CRUDServices";

export const filterQuestionBank: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "question-bank",
  async (body: any) => {
    let { data } = await filterTableDataAPI(
      "/customer-api/question/v1/s1/grid",
      body.pageNumber,
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      true,
      10,
      false
    );

    console.log("data is",data)
    return { data:data.response };
  }
);

const initialState: any = {
  questionBankData: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
};

const QuestionBankSlice = createSlice({
  initialState: initialState,
  name: "question-bank",
  reducers: {

    // clearGroupPayment: (state) => {
    //   state.deliveryList = [];
    // },
    setFilterQuestionBank: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterQuestionBank.fulfilled as any]: (state, action) => {
      state.questionBankData = action.payload.data;
      state.fetchpost = false;
    },
    [filterQuestionBank.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterQuestionBank.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const {  setFilterQuestionBank } = QuestionBankSlice.actions;
export default QuestionBankSlice.reducer;
